(() => {
  const els = document.querySelectorAll(".cutoff-timer");
  if (!els.length) return;

  const isoWeekday = (wk) => ({ Mon:1, Tue:2, Wed:3, Thu:4, Fri:5, Sat:6, Sun:7 }[wk] || 0);

  function getZonedParts(date, timeZone) {
    const dtf = new Intl.DateTimeFormat("en-GB", {
      timeZone,
      year: "numeric",
      month: "2-digit",
      day: "2-digit",
      hour: "2-digit",
      minute: "2-digit",
      second: "2-digit",
      hour12: false,
      weekday: "short",
    });
    const parts = Object.fromEntries(dtf.formatToParts(date).map(p => [p.type, p.value]));
    return {
      year: Number(parts.year),
      month: Number(parts.month),
      day: Number(parts.day),
      hour: Number(parts.hour),
      minute: Number(parts.minute),
      second: Number(parts.second),
      weekday: parts.weekday,
    };
  }

  // Turn a "local time in Europe/London" into a real Date (UTC instant)
  function zonedToUtc({ year, month, day, hour, minute, second }, timeZone) {
    const guess = new Date(Date.UTC(year, month - 1, day, hour, minute, second || 0));
    const z = getZonedParts(guess, timeZone);
    const intended = Date.UTC(year, month - 1, day, hour, minute, second || 0);
    const got = Date.UTC(z.year, z.month - 1, z.day, z.hour, z.minute, z.second || 0);
    return new Date(guess.getTime() + (intended - got));
  }

  function parseHHMM(str) {
    const [h, m] = String(str).split(":").map(Number);
    return { h: Number.isFinite(h) ? h : 14, m: Number.isFinite(m) ? m : 0 };
  }

  function pad2(n){ return String(n).padStart(2,"0"); }

  function formatRemaining(ms) {
    const totalSec = Math.max(0, Math.floor(ms / 1000));
    const h = Math.floor(totalSec / 3600);
    const m = Math.floor((totalSec % 3600) / 60);
    const s = totalSec % 60;
    if (h > 0) return `${h}h ${pad2(m)}m`;
    return `${m}m ${pad2(s)}s`;
  }

  function addDaysInZone(y, mo, d, days, timeZone) {
    // Use noon to avoid DST edges, then jump forward in UTC and re-read zoned parts.
    const utcNoon = zonedToUtc({ year: y, month: mo, day: d, hour: 12, minute: 0, second: 0 }, timeZone);
    const jumped = new Date(utcNoon.getTime() + days * 24 * 60 * 60 * 1000);
    const p = getZonedParts(jumped, timeZone);
    return { year: p.year, month: p.month, day: p.day };
  }

  function nextCutoff(now, timeZone, cutoffStr) {
    const { h, m } = parseHHMM(cutoffStr);
    const nowZ = getZonedParts(now, timeZone);
    const wk = isoWeekday(nowZ.weekday);

    // If Sat (6) -> +2 days to Mon. If Sun (7) -> +1 day to Mon.
    if (wk === 6) {
      const mon = addDaysInZone(nowZ.year, nowZ.month, nowZ.day, 2, timeZone);
      return zonedToUtc({ ...mon, hour: h, minute: m, second: 0 }, timeZone);
    }
    if (wk === 7) {
      const mon = addDaysInZone(nowZ.year, nowZ.month, nowZ.day, 1, timeZone);
      return zonedToUtc({ ...mon, hour: h, minute: m, second: 0 }, timeZone);
    }

    // Mon–Fri:
    const todayCutoff = zonedToUtc(
      { year: nowZ.year, month: nowZ.month, day: nowZ.day, hour: h, minute: m, second: 0 },
      timeZone
    );

    if (now < todayCutoff) return todayCutoff;

    // after cutoff: next weekday (Fri after cutoff -> Monday)
    const daysToAdd = (wk === 5) ? 3 : 1;
    const next = addDaysInZone(nowZ.year, nowZ.month, nowZ.day, daysToAdd, timeZone);
    return zonedToUtc({ ...next, hour: h, minute: m, second: 0 }, timeZone);
  }

  els.forEach((el) => {
    const cutoff = el.dataset.cutoffTime || "14:00";
    const timeZone = el.dataset.timezone || "Europe/London";
    const countdownEl = el.querySelector(".cutoff-timer__countdown");
    const suffixEl = el.querySelector(".cutoff-timer__suffix");
    if (!countdownEl) return;

    const tick = () => {
      const now = new Date();

      const target = nextCutoff(now, timeZone, cutoff);

      const remaining = target.getTime() - now.getTime();

      countdownEl.textContent = formatRemaining(remaining);

      if (suffixEl) {
        const nowZ = getZonedParts(now, timeZone);
        const tZ = getZonedParts(target, timeZone);

        const sameDay =
            nowZ.year === tZ.year &&
            nowZ.month === tZ.month &&
            nowZ.day === tZ.day;

        const longDay = { Mon:"Monday", Tue:"Tuesday", Wed:"Wednesday", Thu:"Thursday", Fri:"Friday", Sat:"Saturday", Sun:"Sunday" }[tZ.weekday] || tZ.weekday;

        if (sameDay) {
            suffixEl.textContent = "for dispatch today.";
        } else {
            suffixEl.textContent = `for dispatch ${longDay}.`;
        }
			}
    }

    tick();
    setInterval(tick, 1000);
  });
})();
